import React, { useState } from 'react';
import { Box, Container, Typography, Button, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Array de slides
  const slides = [
    {
      bgImage: '/american-college.jpg', 
      badge: 'Fastest Way To Learn Anything',
      title: 'Ready To Study with us?',
      buttonText: 'Learn More',
    },
    {
      bgImage: '/american-college.jpg',
      badge: 'Excellence in Education',
      title: 'Your Future Starts Here',
      buttonText: 'Explore More',
    },
    {
      bgImage: '/american-college.jpg',
      badge: 'Quality Learning Experience',
      title: 'Transform Your Future',
      buttonText: 'Get Started',
    },
  ];

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: { xs: 'auto', md: '700px' }, 
        minHeight: { xs: '650px', md: 'unset' },
        overflow: 'hidden',
        backgroundColor: '#1a1f5c',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {/* Background Image with Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          ...(slides[currentSlide].bgImage && slides[currentSlide].bgImage !== '' && {
            backgroundImage: `url(${slides[currentSlide].bgImage})`,
          }),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transition: 'background-image 0.5s ease-in-out',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(26, 31, 92, 0.85)',
          },
        }}
      />

      {/* Palm Tree Silhouette - Left */}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: { xs: '60px', md: '120px' },
          height: '100%',
          backgroundImage: 'url(/palm-left.png)',
          backgroundSize: 'contain',
          backgroundPosition: 'left top',
          backgroundRepeat: 'no-repeat',
          opacity: 0.4,
          zIndex: 1,
        }}
      />

      <Container 
        maxWidth="lg" 
        sx={{ 
          position: 'relative', 
          zIndex: 2, 
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 8, md: 0 }, 
        }}
      >
        {/* Contenedor centralizado para todo el contenido de texto y CTAs */}
        <Box 
          sx={{ 
            width: '100%',
            maxWidth: '800px', // Limita el ancho del título para mejorar legibilidad
            color: 'white',
            textAlign: 'center', // Centra todo el bloque de texto
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', // Centra el Badge y el Botón horizontalmente
            mx: 'auto',
          }}
        >
          {/* Badge */}
          <Box
            sx={{
              display: 'inline-block',
              backgroundColor: '#00BCD4',
              color: 'white',
              px: 3,
              py: 1,
              borderRadius: '25px',
              fontSize: '0.9rem',
              fontWeight: 600,
              mb: 3,
              animation: 'fadeIn 0.6s ease-in-out',
              '@keyframes fadeIn': {
                from: { opacity: 0, transform: 'translateY(-10px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            {slides[currentSlide].badge}
          </Box>

          {/* Title */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' }, 
              fontWeight: 700,
              lineHeight: 1.15,
              mb: 4,
              animation: 'fadeInUp 0.8s ease-in-out',
              '@keyframes fadeInUp': {
                from: { opacity: 0, transform: 'translateY(20px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            {slides[currentSlide].title}
          </Typography>

          {/* Button */}
          <Button
            variant="contained"
            size="large"
            href="/about-us/admissions"
            sx={{
              backgroundColor: '#E31E24',
              color: 'white',
              px: 6,
              py: 1.8,
              fontSize: '1.05rem',
              fontWeight: 600,
              borderRadius: '30px',
              textTransform: 'none',
              boxShadow: '0 8px 20px rgba(227, 30, 36, 0.4)',
              animation: 'fadeIn 1s ease-in-out',
              '&:hover': {
                backgroundColor: '#C41A1F',
                transform: 'translateY(-2px)',
                boxShadow: '0 12px 28px rgba(227, 30, 36, 0.5)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            {slides[currentSlide].buttonText}
          </Button>
        </Box>
      </Container>

      {/* Flechas de navegación */}
      <IconButton
        onClick={handlePrevSlide}
        sx={{
          position: 'absolute',
          left: { xs: 10, md: 30 },
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 3,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          color: '#2B2B6B',
          width: { xs: 40, md: 50 },
          height: { xs: 40, md: 50 },
          '&:hover': {
            backgroundColor: 'white',
            transform: 'translateY(-50%) scale(1.1)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      <IconButton
        onClick={handleNextSlide}
        sx={{
          position: 'absolute',
          right: { xs: 10, md: 30 },
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 3,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          color: '#2B2B6B',
          width: { xs: 40, md: 50 },
          height: { xs: 40, md: 50 },
          '&:hover': {
            backgroundColor: 'white',
            transform: 'translateY(-50%) scale(1.1)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      {/* Dots/Paginación */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 30,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: 1.5,
          zIndex: 3,
        }}
      >
        {slides.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentSlide(index)}
            sx={{
              width: currentSlide === index ? 40 : 12,
              height: 12,
              borderRadius: 6,
              backgroundColor: currentSlide === index ? '#E31E24' : 'rgba(255, 255, 255, 0.5)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: currentSlide === index ? '#E31E24' : 'rgba(255, 255, 255, 0.8)',
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Hero;